function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("line", {
  x1: 136.5,
  y1: 13.7968,
  x2: 136.5,
  y2: 147.427,
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 =
/*#__PURE__*/
React.createElement("line", {
  x1: 141.5,
  y1: 27.4597,
  x2: 141.5,
  y2: 133.764,
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 =
/*#__PURE__*/
React.createElement("line", {
  x1: 131.5,
  y1: 36.5683,
  x2: 131.5,
  y2: 124.655,
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 =
/*#__PURE__*/
React.createElement("line", {
  x1: 146.5,
  y1: 41.1229,
  x2: 146.5,
  y2: 120.101,
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 =
/*#__PURE__*/
React.createElement("line", {
  x1: 126.5,
  y1: 27.4597,
  x2: 126.5,
  y2: 133.764,
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 =
/*#__PURE__*/
React.createElement("line", {
  x1: 161.5,
  y1: 4.68811,
  x2: 161.5,
  y2: 156.536,
  stroke: "#43CDA3",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 =
/*#__PURE__*/
React.createElement("line", {
  x1: 121.5,
  y1: 45.6772,
  x2: 121.5,
  y2: 115.547,
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 =
/*#__PURE__*/
React.createElement("line", {
  x1: 171.5,
  y1: 45.6772,
  x2: 171.5,
  y2: 115.547,
  stroke: "black",
  strokeOpacity: 0.15,
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 =
/*#__PURE__*/
React.createElement("line", {
  x1: 261.5,
  y1: 45.6772,
  x2: 261.5,
  y2: 115.547,
  stroke: "black",
  strokeOpacity: 0.15,
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 =
/*#__PURE__*/
React.createElement("line", {
  x1: 151.5,
  y1: 50.2316,
  x2: 151.5,
  y2: 110.992,
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref12 =
/*#__PURE__*/
React.createElement("line", {
  x1: 111.5,
  y1: 54.7859,
  x2: 111.5,
  y2: 106.438,
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref13 =
/*#__PURE__*/
React.createElement("line", {
  x1: 106.5,
  y1: 59.3402,
  x2: 106.5,
  y2: 101.884,
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref14 =
/*#__PURE__*/
React.createElement("line", {
  x1: 116.5,
  y1: 59.3402,
  x2: 116.5,
  y2: 101.884,
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref15 =
/*#__PURE__*/
React.createElement("line", {
  x1: 56.5,
  y1: 63.8945,
  x2: 56.5,
  y2: 97.3293,
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref16 =
/*#__PURE__*/
React.createElement("line", {
  x1: 176.5,
  y1: 63.8945,
  x2: 176.5,
  y2: 97.3293,
  stroke: "black",
  strokeOpacity: 0.15,
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref17 =
/*#__PURE__*/
React.createElement("line", {
  x1: 156.5,
  y1: 63.8945,
  x2: 156.5,
  y2: 97.3293,
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref18 =
/*#__PURE__*/
React.createElement("line", {
  x1: 266.5,
  y1: 63.8945,
  x2: 266.5,
  y2: 97.3293,
  stroke: "black",
  strokeOpacity: 0.15,
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref19 =
/*#__PURE__*/
React.createElement("line", {
  x1: 96.5,
  y1: 68.4488,
  x2: 96.5,
  y2: 92.7749,
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref20 =
/*#__PURE__*/
React.createElement("line", {
  x1: 76.5,
  y1: 68.4488,
  x2: 76.5,
  y2: 92.7749,
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref21 =
/*#__PURE__*/
React.createElement("line", {
  x1: 271.5,
  y1: 68.4488,
  x2: 271.5,
  y2: 92.7749,
  stroke: "black",
  strokeOpacity: 0.15,
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref22 =
/*#__PURE__*/
React.createElement("line", {
  x1: 166.5,
  y1: 68.4488,
  x2: 166.5,
  y2: 92.7749,
  stroke: "black",
  strokeOpacity: 0.15,
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref23 =
/*#__PURE__*/
React.createElement("line", {
  x1: 91.5,
  y1: 73.0031,
  x2: 91.5,
  y2: 88.2205,
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref24 =
/*#__PURE__*/
React.createElement("line", {
  x1: 51.5,
  y1: 73.0031,
  x2: 51.5,
  y2: 88.2205,
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref25 =
/*#__PURE__*/
React.createElement("line", {
  x1: 81.5,
  y1: 73.0031,
  x2: 81.5,
  y2: 88.2205,
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref26 =
/*#__PURE__*/
React.createElement("line", {
  x1: 66.5,
  y1: 73.0031,
  x2: 66.5,
  y2: 88.2205,
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref27 =
/*#__PURE__*/
React.createElement("line", {
  x1: 26.5,
  y1: 73.0031,
  x2: 26.5,
  y2: 88.2205,
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref28 =
/*#__PURE__*/
React.createElement("line", {
  x1: 86.5,
  y1: 77.5577,
  x2: 86.5,
  y2: 83.6664,
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref29 =
/*#__PURE__*/
React.createElement("line", {
  x1: 61.5,
  y1: 77.5577,
  x2: 61.5,
  y2: 83.6664,
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref30 =
/*#__PURE__*/
React.createElement("line", {
  x1: 41.5,
  y1: 77.5577,
  x2: 41.5,
  y2: 83.6664,
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref31 =
/*#__PURE__*/
React.createElement("line", {
  x1: 16.5,
  y1: 77.5577,
  x2: 16.5,
  y2: 83.6664,
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref32 =
/*#__PURE__*/
React.createElement("line", {
  x1: 31.5,
  y1: 77.5577,
  x2: 31.5,
  y2: 83.6664,
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref33 =
/*#__PURE__*/
React.createElement("line", {
  x1: 6.49999,
  y1: 77.5577,
  x2: 6.49999,
  y2: 83.6664,
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref34 =
/*#__PURE__*/
React.createElement("line", {
  x1: 46.5,
  y1: 79.8348,
  x2: 46.5,
  y2: 81.3892,
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref35 =
/*#__PURE__*/
React.createElement("line", {
  x1: 36.5,
  y1: 79.8348,
  x2: 36.5,
  y2: 81.3892,
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref36 =
/*#__PURE__*/
React.createElement("line", {
  x1: 11.5,
  y1: 79.8348,
  x2: 11.5,
  y2: 81.3892,
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref37 =
/*#__PURE__*/
React.createElement("line", {
  x1: 21.5,
  y1: 79.8348,
  x2: 21.5,
  y2: 81.3892,
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref38 =
/*#__PURE__*/
React.createElement("line", {
  x1: 1.5,
  y1: 79.8348,
  x2: 1.5,
  y2: 81.3892,
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref39 =
/*#__PURE__*/
React.createElement("line", {
  x1: 71.5,
  y1: 77.5577,
  x2: 71.5,
  y2: 83.6664,
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref40 =
/*#__PURE__*/
React.createElement("line", {
  x1: 236.5,
  y1: 63.8945,
  x2: 236.5,
  y2: 97.3293,
  stroke: "black",
  strokeOpacity: 0.15,
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref41 =
/*#__PURE__*/
React.createElement("line", {
  x1: 256.5,
  y1: 68.4488,
  x2: 256.5,
  y2: 92.7749,
  stroke: "black",
  strokeOpacity: 0.15,
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref42 =
/*#__PURE__*/
React.createElement("line", {
  x1: 231.5,
  y1: 73.0031,
  x2: 231.5,
  y2: 88.2205,
  stroke: "black",
  strokeOpacity: 0.15,
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref43 =
/*#__PURE__*/
React.createElement("line", {
  x1: 246.5,
  y1: 73.0031,
  x2: 246.5,
  y2: 88.2205,
  stroke: "black",
  strokeOpacity: 0.15,
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref44 =
/*#__PURE__*/
React.createElement("line", {
  x1: 276.5,
  y1: 73.0031,
  x2: 276.5,
  y2: 88.2205,
  stroke: "black",
  strokeOpacity: 0.15,
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref45 =
/*#__PURE__*/
React.createElement("line", {
  x1: 206.5,
  y1: 73.0031,
  x2: 206.5,
  y2: 88.2205,
  stroke: "black",
  strokeOpacity: 0.15,
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref46 =
/*#__PURE__*/
React.createElement("line", {
  x1: 241.5,
  y1: 77.5577,
  x2: 241.5,
  y2: 83.6664,
  stroke: "black",
  strokeOpacity: 0.15,
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref47 =
/*#__PURE__*/
React.createElement("line", {
  x1: 221.5,
  y1: 77.5577,
  x2: 221.5,
  y2: 83.6664,
  stroke: "black",
  strokeOpacity: 0.15,
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref48 =
/*#__PURE__*/
React.createElement("line", {
  x1: 286.5,
  y1: 77.5577,
  x2: 286.5,
  y2: 83.6664,
  stroke: "black",
  strokeOpacity: 0.15,
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref49 =
/*#__PURE__*/
React.createElement("line", {
  x1: 296,
  y1: 77.5577,
  x2: 296,
  y2: 83.6664,
  stroke: "black",
  strokeOpacity: 0.15,
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref50 =
/*#__PURE__*/
React.createElement("line", {
  x1: 196.5,
  y1: 77.5577,
  x2: 196.5,
  y2: 83.6664,
  stroke: "black",
  strokeOpacity: 0.15,
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref51 =
/*#__PURE__*/
React.createElement("line", {
  x1: 211.5,
  y1: 77.5577,
  x2: 211.5,
  y2: 83.6664,
  stroke: "black",
  strokeOpacity: 0.15,
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref52 =
/*#__PURE__*/
React.createElement("line", {
  x1: 186.5,
  y1: 77.5577,
  x2: 186.5,
  y2: 83.6664,
  stroke: "black",
  strokeOpacity: 0.15,
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref53 =
/*#__PURE__*/
React.createElement("line", {
  x1: 226.5,
  y1: 79.8348,
  x2: 226.5,
  y2: 81.3892,
  stroke: "black",
  strokeOpacity: 0.15,
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref54 =
/*#__PURE__*/
React.createElement("line", {
  x1: 281.5,
  y1: 79.8348,
  x2: 281.5,
  y2: 81.3892,
  stroke: "black",
  strokeOpacity: 0.15,
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref55 =
/*#__PURE__*/
React.createElement("line", {
  x1: 301.5,
  y1: 79.8348,
  x2: 301.5,
  y2: 81.3892,
  stroke: "black",
  strokeOpacity: 0.15,
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref56 =
/*#__PURE__*/
React.createElement("line", {
  x1: 291,
  y1: 79.8348,
  x2: 291,
  y2: 81.3892,
  stroke: "black",
  strokeOpacity: 0.15,
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref57 =
/*#__PURE__*/
React.createElement("line", {
  x1: 216.5,
  y1: 79.8348,
  x2: 216.5,
  y2: 81.3892,
  stroke: "black",
  strokeOpacity: 0.15,
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref58 =
/*#__PURE__*/
React.createElement("line", {
  x1: 191.5,
  y1: 79.8348,
  x2: 191.5,
  y2: 81.3892,
  stroke: "black",
  strokeOpacity: 0.15,
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref59 =
/*#__PURE__*/
React.createElement("line", {
  x1: 201.5,
  y1: 79.8348,
  x2: 201.5,
  y2: 81.3892,
  stroke: "black",
  strokeOpacity: 0.15,
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref60 =
/*#__PURE__*/
React.createElement("line", {
  x1: 181.5,
  y1: 79.8348,
  x2: 181.5,
  y2: 81.3892,
  stroke: "black",
  strokeOpacity: 0.15,
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref61 =
/*#__PURE__*/
React.createElement("line", {
  x1: 251.5,
  y1: 77.5577,
  x2: 251.5,
  y2: 83.6664,
  stroke: "black",
  strokeOpacity: 0.15,
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref62 =
/*#__PURE__*/
React.createElement("line", {
  x1: 101.5,
  y1: 77.5577,
  x2: 101.5,
  y2: 83.6664,
  stroke: "black",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref63 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 161.5,
  cy: 3.48692,
  rx: 3.5,
  ry: 3.48692,
  fill: "#43CDA3"
});

var _ref64 =
/*#__PURE__*/
React.createElement("ellipse", {
  cx: 161.5,
  cy: 156.513,
  rx: 3.5,
  ry: 3.48692,
  fill: "#43CDA3"
});

var SvgSound = function SvgSound(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 275,
    height: 160,
    viewBox: "0 0 303 160",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61, _ref62, _ref63, _ref64);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSound, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Sound.9d63a2c0.svg";
export { ForwardRef as ReactComponent };